module.exports = __webpack_public_path__ + "static/media/26UNRWA23.651dd510.jpg";